import React from 'react';
import Icon from './Icon';

const DrawLineIcon = (props) => (
    <Icon {...props}>
        <path
            d="M7 19A2 2 0 1 1 3 19A2 2 0 0 1 7 19ZM21 5A2 2 0 1 1 17 5A2 2 0 0 1 21 5ZM7 17L17 7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default DrawLineIcon;
